<template>
  <el-form key="mobile" :model="mobileForm" ref="mobileForm">
    <el-form-item prop="mobile">
      <el-input v-model="mobileForm.mobile" placeholder="请输入手机号"></el-input>
    </el-form-item>

    <el-form-item prop="smsCode">
      <el-input
        v-model="mobileForm.smsCode"
        placeholder="请输入验证码"
        @keyup.enter.native="loginOrRegister">
        <template slot="append">
          <el-button @click="sendSms" v-show="!hasSendSms">发送验证码</el-button>
          <span disabled v-show="hasSendSms">{{second}}秒后重新获取</span>
        </template>
      </el-input>
    </el-form-item>

    <div class="mobile-login-tip"><span>第一次使用将自动创建账号</span></div>

    <el-form-item class="login__button">
      <ghidri-button type="primary" size="large" tabindex="0" :loading="loading" @click="loginOrRegister" @keydown.enter.native="loginOrRegister">登录 / 注册</ghidri-button>
    </el-form-item>

    <el-dialog
      title="是否立即修改密码？"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
        <div>
          <h3>欢迎新用户，您的初始密码：</h3>
          <p style="padding: 0 20px;">{{ initPassword }}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button round icon="el-icon-close" @click="handleClose">取 消</el-button>
          <el-button type="primary" round icon="el-icon-check" @click="confirmModify">确 定</el-button>
        </span>
    </el-dialog>

  </el-form>
</template>

<script>
  import loginApi from "@/api/login.js";

  import util from '@/util/util'

  import store from '@/store'

  export default {
    name: "MobileLogin",
    data() {
      return {
        mobileForm: {
          smsCode: "",
          mobile: ""
        },
        loading: false,

        dialogVisible: false,
        initPassword: '',

        hasSendSms: false,//是否发送短信
        second: 60,//短信间隔时间

        redirect: undefined,
      };
    },
    watch: {
      $route: {
        handler: function (route) {
          this.redirect = route.query && route.query.redirect
        },
        immediate: true
      }
    },
    methods: {
      loginOrRegister() {
        const _this = this

        if (!util.verifyMobile(_this.mobileForm.mobile)) {
          _this.$message.warning('手机号不正确')
          return;
        }
        if (!_this.mobileForm.smsCode) {
          _this.$message.warning('请输入验证码')
          return;
        }
        _this.loading = true
        store.dispatch('user/loginOrRegister', _this.mobileForm).then((res) => {
          const initPassword = res.initPassword
          if (initPassword) {
            _this.readyModifyPassword(initPassword)
          } else {
            _this.$router.push({ path: _this.redirect || '/'})
          }
        }).catch((err) => {
          _this.loading = false
          _this.$message.error(err || "网络出错，请稍后再试")
        })
      },

      readyModifyPassword(initPassword) {
        this.initPassword = initPassword;
        this.dialogVisible = true;
      },

      handleClose(done) {
        this.dialogVisible = false
        done();
        this.$router.push({ path: this.redirect || '/'})
      },

      confirmModify: function() {
        this.$router.push({ name: "updatePwd", params: { oldPwd: this.initPassword } });
        this.dialogVisible = false;
      },

      sendSms() {
        const _this = this
        if (!util.verifyMobile(_this.mobileForm.mobile)) {
          _this.$message.warning('请输入手机号')
          return;
        }
        _this.hasSendSms = true
        loginApi.sendSmsCode(_this.mobileForm.mobile).then(res => {
          if (res.success) {
            _this.setTimeOut()
          } else {
            _this.$message.warning(res.msg)
            return;
          }
        }).catch(err => {
          _this.$message.warning(err)
          _this.hasSendSms = false
        })
      },

      setTimeOut() {
        const _this = this
        let timer = setTimeout(() => {
          _this.setTimeOut()
          if (_this.second > 0) {
            _this.second--
          }
        }, 1000)
        if (_this.second <= 0) {
          _this.hasSendSms = false
          _this.second = 60
          clearTimeout(timer)
        }
      }
    }
  };
</script>

<style scoped lang="less">
  .mobile-login-tip {
    line-height: 22px;
    margin-top: -24px;
    text-align: left;
    padding-left: 5px;
    margin-bottom: 40px;
  }

  .mobile-login-tip span {
    color: #aaa;
    font-size: 14px;
  }

  .msg-text {
    display: block;
    width: 60px;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
  }

  .msg-text.display {
    color: #ccc;
  }

</style>
